//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  faLanguage,
  faSearch,
  faFilter,
} from '@fortawesome/pro-light-svg-icons';

import { publishedContentCounts, renderContentCount } from '@motionelements/core/src/helpers/contentCount';

export default {
  name: 'AudioSearchPage',
  components: {
    Breadcrumbs: () => import('@motionelements/core/src/components/ui/BaseBreadcrumbs.vue'),
    PageMeta: () => import('@motionelements/core/src/components/ThePageMeta.vue'),
    SearchLandingPage: () => import('@/components/search-lp/SearchLandingPage.vue'),
  },
  data() {
    return {
      waysToUse: [
        {
          heading: this.$t(this.$wbr('visualsearch.usage_file_heading')),
          text: this.$t('audiosearch.accept_{formats}_less_than_{filesize}_text', { formats: '(JPG, PNG, BMP, GIF, MP4, MOV, WMV, MPG)', filesize: '100MB' }),
          image: 'https://static.moele.me/img/channels2022/visualsearch/video-drag-and-drop-light-and-dark.230829.png?auto=format&w=630',
        },
        {
          heading: this.$t(this.$wbr('visualsearch.usage_similar_heading')),
          image: 'https://static.moele.me/img/channels2022/visualsearch/video-button-dark.230829.png?auto=format&w=630',
          imageDark: 'https://static.moele.me/img/channels2022/visualsearch/video-button-light.230829.png?auto=format&w=630',
        },
      ],
      questions: [
        this.$t(this.$wbr('visualsearch.text_1')),
        this.$t(this.$wbr('visualsearch.text_2')),
        this.$t(this.$wbr('visualsearch.text_3')),
        this.$t(this.$wbr('visualsearch.text_4_{item}'), { item: this.$t('term.visualsearch') }),
      ],
      benefits: [
        {
          icon: faLanguage,
          color: 'aqua',
          heading: this.$t(this.$wbr('visualsearch.benefit_1_heading')),
        },
        {
          icon: faSearch,
          color: 'lavender',
          heading: this.$t(this.$wbr('visualsearch.benefit_2_heading_{count}'), { count: renderContentCount(this, publishedContentCounts.total.element) }),
        },
        {
          icon: faFilter,
          color: 'blue',
          heading: this.$t(this.$wbr('visualsearch.benefit_3_heading')),
        },
      ],
      testimonials: [
        {
          text: 'これは凄い！<br/> 今まで、大量の素材データから自分の好みのデータを探すのがかなり大変だった <br/> でもビジュアルサーチを使うと感覚的にリストアップしてくれる <br/> これは画期的なシステムだ <br/><br/> Awesome! It has always been a challenge to search for videos using large amounts of data. VisualSearch solves that challenge for us and provides intuitive results. This is indeed revolutionary.',
          name: 'Tomoya Saito, Digital Hollywood',
        },
      ],
    };
  },
  computed: {
    pageTitle() {
      return this.$t('term.visualsearch');
    },
    pageDescription() {
      return this.$t('visualsearch.page_subheading');
    },
    pageOgImage() {
      const suffix = ['ja', 'ko', 'zh-hant'].includes(this.$i18n.locale) ? this.$i18n.locale : 'en';
      return `https://static.moele.me/img/visualsearch/visualsearch-og-${suffix}.220830.jpg`;
    },
    breadcrumbList() {
      return [{
        active: false,
        name: this.$term('mediaType', 'video').text(),
        link: this.$link('/video').url(),
      }, {
        active: true,
        name: this.$t('term.visualsearch'),
        link: this.$link('/visualsearch').url(),
      }];
    },
  },
};
